export default __webpack_public_path__ + "static/media/login-bg.7c5ec665.png";